<div class="ui basic segment container negative-space">
    <app-header title="add-ons.header"></app-header>
    <ng-container *ngIf="upsellV2Enabled; else oldView">
        <div class="app-grid upsell-view">
            <app-upsell-v2-card
                *ngFor="let module of inactiveModulesV2"
                class="columns-6 xl-columns-6 large-columns-6 medium-columns-6 margin-bottom-3"
                [tagline]="upsellCardMetaDataV2[module].tagline"
                [src]="upsellCardMetaDataV2[module].src"
                [description]="upsellCardMetaDataV2[module].description"
                [embedURL]="upsellCardMetaDataV2[module].embedURL"
                [externalURL]="upsellCardMetaDataV2[module].externalURL ?? ''"
                [CTAText]="upsellCardMetaDataV2[module].CTAText"
                [dependencyModuleSrc]="
                    !hasBenefitsPlus && module === 'Benefits Plus' ? upsellCardMetaDataV2[modules.benefits].src : ''
                "
                [dependencyModuleTagline]="
                    !hasBenefitsPlus && module === 'Benefits Plus' ? upsellCardMetaDataV2[modules.benefits].tagline : ''
                "
                [moduleName]="upsellCardMetaDataV2[module].moduleName"
                [learnMoreEvent]="upsellCardMetaDataV2[module].learnMoreEvent"
            ></app-upsell-v2-card>
        </div>
    </ng-container>
    <ng-template #oldView>
        <div class="app-grid">
            <app-upsell-card
                class="margin-bottom-3"
                [CTAText]="upsellCardMetaData[modules.benefits].CTAText"
                [header]="upsellCardMetaData[modules.benefits].header"
                [tagline]="upsellCardMetaData[modules.benefits].tagline"
                [src]="upsellCardMetaData[modules.benefits].src"
                [description]="upsellCardMetaData[modules.benefits].description"
                [moduleName]="upsellCardMetaData[modules.benefits].moduleName"
                [taglineImgSrc]="upsellCardMetaData[modules.benefits].taglineSrc"
                [CTAEvent]="upsellCardMetaData[modules.benefits].CTAEvent"
                [learnMoreEvent]="upsellCardMetaData[modules.benefits].learnMoreEvent"
            ></app-upsell-card>
        </div>
        <div class="app-grid">
            <app-upsell-card
                *ngFor="let inactiveModule of inactiveModules"
                class="columns-6 xl-columns-12 large-columns-12 medium-columns-12 margin-bottom-3"
                [CTAText]="upsellCardMetaData[inactiveModule]?.CTAText"
                [header]="upsellCardMetaData[inactiveModule]?.header"
                [tagline]="upsellCardMetaData[inactiveModule]?.tagline"
                [src]="upsellCardMetaData[inactiveModule]?.src"
                [description]="upsellCardMetaData[inactiveModule]?.description"
                [moduleName]="upsellCardMetaData[inactiveModule]?.moduleName"
                [CTAEvent]="upsellCardMetaData[inactiveModule]?.CTAEvent"
                [learnMoreEvent]="upsellCardMetaData[inactiveModule]?.learnMoreEvent"
                [externalURL]="upsellCardMetaData[inactiveModule].externalURL"
            ></app-upsell-card>
            <app-upsell-card
                class="columns-6 xl-columns-12 large-columns-12 medium-columns-12 margin-bottom-3"
                [CTAText]="upsellCardMetaData[modules.businessInsurance].CTAText"
                [header]="upsellCardMetaData[modules.businessInsurance].header"
                [tagline]="upsellCardMetaData[modules.businessInsurance].tagline"
                [src]="upsellCardMetaData[modules.businessInsurance].src"
                [description]="upsellCardMetaData[modules.businessInsurance].description"
                [moduleName]="upsellCardMetaData[modules.businessInsurance].moduleName"
                [taglineImgSrc]="upsellCardMetaData[modules.businessInsurance].taglineSrc"
                [CTAEvent]="upsellCardMetaData[modules.businessInsurance].CTAEvent"
                [learnMoreEvent]="upsellCardMetaData[modules.businessInsurance].learnMoreEvent"
                [externalURL]="upsellCardMetaData[modules.businessInsurance].externalURL"
            ></app-upsell-card>
        </div>
    </ng-template>
</div>
